import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Constant } from '../constant/constant';

@Injectable({
  providedIn: 'root'
})
export class DownloadImageService {

  constructor(private http: HttpClient) { }

  downloadImageNew(imageUrl: any, customFileName?: string) {
    this.http.get(imageUrl, { responseType: 'blob' }).subscribe({
      next: (response: any) => {
        const contentType = response.type;
        const blob = new Blob([response], { type: contentType });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = customFileName || this.extractImageName(imageUrl) || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      },
      error: (err: any) => {
        console.error('Error downloading image', err);
      }
    });
  }

  downloadImageNew1(imageUrl: string): void {
    this.http.get(imageUrl, { responseType: 'blob' }).subscribe(blob => {
      const contentType = blob.type;
      const downloadBlob = new Blob([blob], { type: contentType });

      // Create a temporary link element
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(downloadBlob);
      link.download = this.extractImageName(imageUrl);

      // Append the link to the DOM
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Remove the link from the DOM and revoke the object URL to avoid memory leaks
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    }, error => {
      console.error('Error downloading the image', error);
    });
  }

  /**
   * Downloads a WhatsApp media file.
   * For Lookaside / Facebook CDN URLs the download is routed through the
   * backend proxy with the correct x-tenant header so the server can fetch
   * the media bytes on behalf of the browser (avoids 401 / CORS).
   */
  downloadMediaByUrl(originalUrl: string, fileName?: string): void {
    const isLookaside =
      originalUrl.includes('lookaside.fbsbx.com') ||
      originalUrl.includes('fbsbx.com') ||
      originalUrl.includes('whatsapp_business/attachments');

    const tenant = this.getTenantIdFromCookie();

    let fetchUrl: string;
    let headers: HttpHeaders;

    if (isLookaside) {
      fetchUrl = `${environment.serverAPI8}/api/whatsapp/download-media/image?url=${encodeURIComponent(originalUrl)}`;
      headers = new HttpHeaders({ 'x-tenant': tenant });
    } else {
      fetchUrl = originalUrl;
      headers = new HttpHeaders();
    }

    this.http.get(fetchUrl, { headers, responseType: 'blob' }).subscribe({
      next: (blob: Blob) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName || this.extractImageName(originalUrl);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      },
      error: (err) => {
        console.error('Error downloading media', err);
      }
    });
  }

  /** Reads the c-id cookie (tenant ID). */
  private getTenantIdFromCookie(): string {
    const name = 'c-id=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      const c = ca[i].trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length);
      }
    }
    return localStorage.getItem(Constant.enterPriseKey) || '';
  }

  // extractImageName(url: string): string {
  //   // Split the URL by '/'
  //   const parts = url.split('/');
  //   // Get the last part which contains the file name
  //   const fileName = parts[parts.length - 1];
  //   // Split the file name by '=' to extract the file name

  //   // Return the decoded file name
  //   return decodeURIComponent(fileName);
  // }


  extractImageName(url: string): string {
    if (url.includes('fileName=')) {
      const match = url.match(/[?&]fileName=([^&]+)/);
      if (match && match[1]) {
        const filePart = match[1].split('/').pop() || '';
        return decodeURIComponent(filePart);
      }
    }
    const parts = url.split('/');
    let fileName = parts[parts.length - 1];
    fileName = fileName.split(/[?&]/)[0];
    return decodeURIComponent(fileName);
  }


}
